import { DESCRIPTION, METHOD_NAME } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { routes } from "@/routes/utils";
import { schema } from "./validations";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Payment Method",
    moduleRoute: `${routes.masterData}/${routes.paymentMethod}`,
    schema,
    defaultValues: { [METHOD_NAME]: "", [DESCRIPTION]: "" },
    nameFieldKey: METHOD_NAME,
    queryKeyToInvalidate: "payment-method",
    module: "payment-method",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Method Name"
    />
  );
};

export default AddEdit;
